import { Button, Modal, ModalCloseButton, ModalFooter } from '@tryhackme/thm-ui-components';
import { useStepper } from 'src/common/hooks/use-stepper-modal';
import { StyledFooterButtonsWrapper } from './stepper-modal.styles';
import type { StepperProps } from './stepper-modal.types';
export const StepperModal = ({
  steps,
  onOpenChange,
  initialStep = 0,
  ...props
}: StepperProps) => {
  const {
    getStepper
  } = useStepper();
  const {
    currentStep,
    isFirstStep,
    isLastStep,
    prevStep,
    nextStep
  } = getStepper(props.id, steps.length, initialStep, props.onNext, props.onPrevious);
  const handleClose = (open: boolean) => {
    onOpenChange?.(open);
  };

  // When stepControllers is null, it will not show the default footer buttons
  // to see the default footer buttons, set stepControllers to undefined or simply remove it
  const showControllers = !!steps[currentStep]?.stepControllers || steps[currentStep]?.stepControllers === null;
  return <Modal onOpenChange={handleClose} {...props} data-sentry-element="Modal" data-sentry-component="StepperModal" data-sentry-source-file="stepper-modal.tsx">
      {steps[currentStep]?.component}
      {showControllers ? steps[currentStep]?.stepControllers : <ModalFooter isSmall>
          <StyledFooterButtonsWrapper>
            {isFirstStep ? <ModalCloseButton text="Cancel" /> : <Button variant="outlined" color="primary" onClick={prevStep}>
                Back
              </Button>}
            <Button variant="outlined" color="primary" onClick={nextStep}>
              {isLastStep ? 'Confirm' : 'Next'}
            </Button>
          </StyledFooterButtonsWrapper>
        </ModalFooter>}
    </Modal>;
};